module.exports = __webpack_public_path__ + "img/playne.fe91be74.svg";